import React from 'react';

const AsyncResetPasswordPageContainer = React.lazy(
  () => import('./ResetPasswordPageContainer')
);

export default AsyncResetPasswordPageContainer;